import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ProjectList from '../../components/Attendance/projectList'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v3_attendanceProjectList } from '../../actions/v3/attendance'
import moment from 'moment';
import ExportColumnModal from '../../components/common/ExportColumnModal';
import RecordListFilters from '../../components/common/RecordListFilters';
import { exportRowsToExcel, getLoggedInUserRoleId, replacePageState } from '../../utils';
import { hasPermission } from '../../utils/hasPermission';
const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)
    const [filters, setFilters] = useState({ fromDate: '', toDate: '', name: '', subject: '' });
    const [isExporting, setIsExporting] = useState(false);
    const isAdmin = Number(getLoggedInUserRoleId()) === 1;
    const canManageAttendance = isAdmin || hasPermission(constant.actionPermission.attendanceManageRecords);
    const exportColumns = [
        { key: 'projectCode', label: 'Project Code', value: item => item.PROJECT_CODE },
        { key: 'projectName', label: 'Project Name', value: item => item.PROJECT_NAME },
        { key: 'attendanceDays', label: 'Attendance Days Marked', value: item => item.attendance_days },
    ];

    useEffect(() => {
        v3_attendanceProjectList(currentPage, limit, filters).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.attendanceProjectList.url, {
                    page: currentPage // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit, filters])

    const updateFilters = (nextFilters) => {
        setCurrentPage(1);
        setFilters(nextFilters);
    };

    const exportProjects = async (selectedColumns = exportColumns) => {
        try {
            setIsExporting(true);
            const rows = [];
            let exportPage = 1;
            while (true) {
                const res = await v3_attendanceProjectList(exportPage, 200, filters);
                if (!res?.status) throw new Error(res?.error || 'Unable to export attendance projects.');
                const pageRows = res.result?.projects || [];
                rows.push(...pageRows);
                if (pageRows.length < 200) break;
                exportPage += 1;
            }
            if (!rows.length) return toast.warn('No attendance projects to export.');
            exportRowsToExcel({ rows, columns: selectedColumns, sheetName: 'Attendance Projects', fileName: `Attendance_Projects_${moment().format('YYYYMMDD_HHmmss')}.xlsx` });
        } catch (error) {
            toast.error(error?.message || 'Unable to export attendance projects.');
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <Layout
            title={'Attendance'}
        >
            <RecordListFilters value={filters} onChange={updateFilters} showName={false} subjectLabel="Project name / code" />
            <div className="d-flex justify-content-end mb-3">
                <button className="btn btn-sm btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#attendance-project-export-columns-modal" disabled={isExporting}>
                    <i className={`mdi ${isExporting ? 'mdi-loading mdi-spin' : 'mdi-file-excel-outline'} label-icon`} /> {isExporting ? 'Exporting...' : 'Export'}
                </button>
            </div>
            {data && <ProjectList
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                canEdit={canManageAttendance}
            />}
            <ExportColumnModal modalId="attendance-project-export-columns-modal" title="Select Attendance Columns" columns={exportColumns} onExport={exportProjects} isExporting={isExporting} />
        </Layout>
    )
}

export default List
